module.exports = __webpack_public_path__ + "img/thumbnail_PlainsZebra_f_albino.5685caa3.png";